import {
  captureViewportJpegBlob,
  getCurrentViewportImageIndex,
} from './captureViewportJpeg';
import { classifyDownloadError } from './downloadError';
import { DOWNLOAD_MESSAGES } from './downloadMessages';
import {
  buildStudyJpegFilename,
  getStudyFilenameParts,
} from './filenameUtils';
import { triggerBrowserDownload } from './buildStudyDicomZipFilename';
import {
  collectStudyDicomInstances,
  resolveStudyInstanceUIDFromViewport,
} from './resolveViewportStudy';

export type DownloadCurrentImageJpegOptions = {
  viewportId: string;
  servicesManager: AppTypes.ServicesManager;
  extensionManager: AppTypes.ExtensionManager;
};

export type DownloadCurrentImageJpegResult =
  | { success: true; filename: string }
  | { success: false; message: string };

export async function downloadCurrentImageJpeg({
  viewportId,
  servicesManager,
  extensionManager,
}: DownloadCurrentImageJpegOptions): Promise<DownloadCurrentImageJpegResult> {
  const studyInstanceUID = resolveStudyInstanceUIDFromViewport(viewportId, servicesManager);

  if (!studyInstanceUID) {
    return { success: false, message: DOWNLOAD_MESSAGES.NO_JPEG_AVAILABLE };
  }

  const instances = collectStudyDicomInstances(studyInstanceUID);
  const { studyDate, studyId } = getStudyFilenameParts(
    studyInstanceUID,
    instances,
    servicesManager
  );
  const imageIndex = getCurrentViewportImageIndex(viewportId, servicesManager);

  try {
    const jpegBlob = await captureViewportJpegBlob(
      viewportId,
      servicesManager,
      extensionManager
    );
    const filename = buildStudyJpegFilename(studyDate, studyId, imageIndex);
    triggerBrowserDownload(jpegBlob, filename);

    return { success: true, filename };
  } catch (error) {
    console.error('[ViewportDownload] Current image JPEG export failed:', error);
    return { success: false, message: classifyDownloadError(error) };
  }
}
